module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/krzysztof-walaszek-83d406892c182602bd00ae821f665362.webp";